export const productCategoryQueryKeys = {
  id: 'id',
  productName: 'product_name',
  productCategory: {
    id: 'product_category_id',
    name: 'product_category_name',
  },
  itemCode: 'item_code',
  barcode: 'barcode',
  type: 'type',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
  stateId: 'state_id',
}
